import { render, staticRenderFns } from "./SaveLeaderBoardModal.vue?vue&type=template&id=72e985d2"
import script from "./SaveLeaderBoardModal.vue?vue&type=script&lang=js"
export * from "./SaveLeaderBoardModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports